
<template>
  <div>
    <div v-if="tableId === 'myLeavesTable'" class="row">
      <div class="col-md-12 d-flex justify-content-between">
        <div style="background: #f2f2f2; width: 20%" class="card">
          <div class="card-body d-flex align-items-center">
            <div class="col-12 col-md-12">
              <div class="numbers d-flex flex-column">
                <p class="card-category text-success fw-600 fs-18">
                  Approved Leaves ({{year}})
                </p>
                <p class="card-title">{{getApprovedLeaves}}</p><p>
              </p></div>
            </div>
          </div>
        </div>
        <div style="background: #f2f2f2; width: 20%" class="card ml-10">
          <div class="card-body d-flex align-items-center">
            <div class="col-12 col-md-12">
              <div class="numbers d-flex flex-column">
                <p class="card-category text-warning fw-600 fs-18">
                  Pending Leaves ({{year}})
                </p>
                <p class="card-title">{{getPendingLeaves}}</p><p>
              </p></div>
            </div>
          </div>
        </div>
        <div style="background: #f2f2f2; width: 20%" class="card ml-10">
          <div class="card-body d-flex align-items-center">
            <div class="col-12 col-md-12">
              <div class="numbers d-flex flex-column">
                <p class="card-category text-info fw-600 fs-18">
                  Work Event Leaves ({{year}})
                </p>
                <p class="card-title">{{ getWorkEventLeaves }}</p><p>
              </p></div>
            </div>
          </div>
        </div>
        <div style="background: #f2f2f2; width: 20%" class="card ml-10">
          <div class="card-body d-flex align-items-center">
            <div class="col-12 col-md-12">
              <div class="numbers d-flex flex-column">
                <p class="card-category text-danger fw-600 fs-18">
                  Declined Leaves ({{year}})
                </p>
                <p class="card-title">{{getRejectedLeaves}}</p><p>
              </p></div>
            </div>
          </div>
        </div>
        <div style="background: #f2f2f2; width: 20%" class="card ml-10">
          <div class="card-body d-flex align-items-center">
            <div class="col-12 col-md-12">
              <div class="numbers d-flex flex-column">
                <p class="card-category text-default fw-600 fs-18">
                  Withdrawn Leaves ({{year}})
                </p>
                <p class="card-title">{{getWithdrawLeaves}}</p><p>
              </p></div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12 col-sm-12 col-lg-12">
        <table :id="tableId" class="table table-bordered">
          <thead class="table-light">
          <tr>
            <th class="text-center">Leave Type</th>
            <th class="text-center">Dates</th>
            <th class="text-center">Duration</th>
            <th class="text-center">Details</th>
            <th class="text-center">Status</th>
            <th class="text-center">Action</th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="(row, index) in modifiedLeaves" :key="index">
            <td v-if="tableId === 'allLeavesTable'" class="text-center">
              <img width="20px" class="rounded-circle mr-10" :src="`https://www.gravatar.com/avatar/${emailHashGravatar(row.email)}?s=50`">
              <span>{{row.firstName}} {{row.lastName}}</span>
            </td>
            <td class="text-center">{{leaveTypes[row.leaveType]}}</td>
            <td width="15%" class="text-center">
            <span v-if="row.leaveType !== 'partialLeave' && !(row.leaveType === 'workEvent' && row.partialLeave)">
              {{row.leaveDays && row.leaveDays.length > 1 ? `${parseDate(row.start)} &nbsp - &nbsp ${parseDate(row.end)}` : parseDate(row.start)}}
            </span>
              <span v-else>{{parseDate(row.partialLeave.date)}} <span class="text-danger fw-600">({{row.partialLeave.from}} - {{row.partialLeave.to}})</span></span>
            </td>
            <td class="text-center">
              <span v-if="row.leaveType === 'workEvent'">Not eligible to count</span>
              <span v-else-if="row.leaveType !== 'partialLeave'">
                {{row.leaveDays && row.leaveDays.length > 0 ? row.leaveDays.length : '-'}}
              </span>
              <span v-else-if="row.leaveType === 'partialLeave'">
                {{getDuration(row)}} (hrs)
              </span>
            </td>
            <td width="20%" class="text-center">
              <span class="make-cursor-pointer" :style="!row.details ? 'opacity: 0.5;' : ''" @mouseover="getTitle(row, true, index)" :id="`${selectedTab}_${index}`" @mouseleave="getTitle(row, false, index)">{{row.details && row.details.length > 500 ? row.details.substring(0,500) + '...' : row.details || 'N/A'}}</span>
            </td>
            <td class="text-center">
              <span class="badge badge-pill" :class="getStatusClass(row.status)">{{row.status}}</span>
            </td>
            <td class="text-center">
              <div class="dropdown">
                <template v-if="index !== selectedIndex">
                  <i class="fa fa-ellipsis-v dropdown-toggle make-cursor-pointer fs-16 pr-20 pl-20" aria-hidden="true" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"></i>
                  <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
                    <a :class="{'disabled': row.status === 'approved' }" @click.prevent="row.status !== 'approved' && withdrawLeave({...row, index})" class="dropdown-item" href="#">Withdraw</a>
                    <a :class="{'disabled': row.status === 'approved' }" @click.prevent="row.status !== 'approved' && deleteLeave({...row, index})" class="dropdown-item" href="#">Delete</a>
                  </div>
                </template>
                <i v-else class="fa fa-spin fa-spinner"></i>
              </div>
            </td>
          </tr>
          </tbody>
        </table>
      </div>
    </div>
    <div v-if="tableId === 'myLeavesTable' && upcomingLeaves.length" class="row mt-30">
      <div class="col-md-12 d-flex justify-content-center">
        <h5 class="font-weight-bold">Other Staff Leaves (Upcoming)</h5>
      </div>
      <div class="col-md-12 col-sm-12 col-lg-12">
        <table class="table table-bordered">
          <thead class="table-light">
          <tr>
            <th class="text-center">Employee Name</th>
            <th class="text-center">Dates</th>
            <th class="text-center">Duration</th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="(row, index) in upcomingLeaves" :key="index">
            <td class="text-center">
              <img width="20px" class="rounded-circle mr-10" :src="`https://www.gravatar.com/avatar/${emailHashGravatar(row.email)}?s=50`">
              <span>{{row.firstName}} {{row.lastName}}</span>
            </td>
            <td width="15%" class="text-center">
              <span v-if="row.leaveType !== 'partialLeave' && !(row.leaveType === 'workEvent' && row.partialLeave)">
                {{row.leaveDays && row.leaveDays.length > 1 ? `${parseDate(row.start)} &nbsp - &nbsp ${parseDate(row.end)}` : parseDate(row.start)}}
              </span>
              <span v-else>{{row.partialLeave.date}} <span class="text-danger fw-600">({{row.partialLeave.from}} - {{row.partialLeave.to}})</span></span>
            </td>
            <td class="text-center">{{ row.leaveDays && row.leaveDays.length > 0 ? row.leaveDays.length : (row.partialLeave ? getDuration(row) + ' hrs' : '-')}}</td>
          </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>
<script>
import md5 from "crypto-js/md5";
import {db} from "@/firebase/init";
import swal from "sweetalert2";
import tippy from "tippy.js";
import 'tippy.js/dist/tippy.css';
import moment from "moment";

export default {
  name: 'LeaveRecords',
  props: {
    leaves: {
      type: Array,
    }
    ,upcomingLeaves: {
      type: Array,
    },
    tableId: {
      type: String
    },
    selectedTab: {
      type: String
    }
  },
  watch: {
    leaves() {
      this.renderDatatable()
    }
  },
  computed: {
    getWorkEventLeaves() {
      const array = this.leaves.filter(leave => leave.status === 'approved' && leave.leaveType === 'workEvent')
      let totalLeaveCount = 0
      let partialTime = 0
      for(const row of array) {
        if(row.leaveType === 'partialLeave' || (row.leaveType === 'workEvent' && row.partialLeave)) {
          if(!row.partialLeave.date.includes(this.year)) continue
          const fromTime = new Date(`${row.partialLeave.date}T${row.partialLeave.from}:00`);
          const toTime = new Date(`${row.partialLeave.date}T${row.partialLeave.to}:00`);
          const diffInMs = toTime - fromTime;
          const totalMinutes = Math.abs(diffInMs / (1000 * 60));
          partialTime = partialTime + totalMinutes
          console.log('partial time', row.partialLeave, partialTime)
        } else {
          row.leaveDays.map(el => {
            if(el.includes(this.year)) {
              totalLeaveCount ++
            }
          })
        }
      }
      console.log('totalLeaveCount', totalLeaveCount)
      totalLeaveCount = totalLeaveCount + Number(partialTime/60)/8
      return totalLeaveCount > 0 ? totalLeaveCount.toFixed(2) : 0
    },
    year() {
      return moment().tz('America/New_York').format('YYYY');
    },
    getApprovedLeaves() {
      const array = this.leaves.filter(leave => leave.status === 'approved' && leave.leaveType !== 'workEvent')
      let totalLeaveCount = 0
      let partialTime = 0
      for(const row of array) {
        if(row.leaveType === 'partialLeave') {
          if(!row.partialLeave.date.includes(this.year)) continue
          const fromTime = new Date(`${row.partialLeave.date}T${row.partialLeave.from}:00`);
          const toTime = new Date(`${row.partialLeave.date}T${row.partialLeave.to}:00`);
          const diffInMs = toTime - fromTime;
          const totalMinutes = Math.abs(diffInMs / (1000 * 60));
          partialTime = partialTime + totalMinutes
          console.log('partial time', row.partialLeave, partialTime)
        } else {
          row.leaveDays.map(el => {
            if(el.includes(this.year)) {
              totalLeaveCount ++
            }
          })
        }
      }
      console.log('totalLeaveCount', totalLeaveCount)
      totalLeaveCount = totalLeaveCount + Number(partialTime/60)/8
      return totalLeaveCount > 0 ? totalLeaveCount.toFixed(2) : 0
    },
    getPendingLeaves() {
      const array = this.leaves.filter(leave => leave.status === 'pending')
      return array.length
    },
    getRejectedLeaves() {
      const array = this.leaves.filter(leave => leave.status === 'rejected')
      let totalLeaveCount = 0
      let partialTime = 0
      for(const row of array) {
        if(row.leaveType === 'partialLeave') {
          if(!row.partialLeave.date.includes(this.year)) continue
          const fromTime = new Date(`${row.partialLeave.date}T${row.partialLeave.from}:00`);
          const toTime = new Date(`${row.partialLeave.date}T${row.partialLeave.to}:00`);
          const diffInMs = toTime - fromTime;
          const totalMinutes = Math.abs(diffInMs / (1000 * 60));
          partialTime = partialTime + totalMinutes
          console.log('partial time', row.partialLeave, partialTime)
        } else {
          row.leaveDays.map(el => {
            if(el.includes(this.year)) {
              totalLeaveCount ++
            }
          })
        }
      }
      console.log('totalLeaveCount', totalLeaveCount)
      totalLeaveCount = totalLeaveCount + Number(partialTime/60)/8
      return totalLeaveCount > 0 ? totalLeaveCount.toFixed(2) : 0
    },
    getWithdrawLeaves() {
      const array = this.leaves.filter(leave => leave.status === 'withdrawn')
      return array.length
    },
    modifiedLeaves() {
      const array = this.leaves.filter(leave => {
        if(leave.leaveType === 'partialLeave' || (leave.leaveType === 'workEvent' && leave.partialLeave)) {
          return leave.partialLeave.date.includes(this.year);
        } else {
          console.log(leave.id, leave.leaveDays)
          if(leave.leaveDays) {
            const arr = leave.leaveDays.filter(el => el.includes(this.year))
            console.log(arr)
            return arr.length > 0
          }
          return false
        }
      });
      return array.sort((a, b) => {
        return new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime()
      })
    }
  },
  data() {
    return {
      selectedIndex: -1,
      leaveTypes: {
        'sick': 'Sick',
        'pto': 'PTO',
        'vacation': 'Vacation',
        'partialLeave': 'Partial Leave',
        'workEvent': 'Work Event',
      }
    }
  },
  methods: {
    async deleteLeave(row) {
      try {
        swal({
          title: "Are you sure?",
          text: "Are you sure that you want to delete leave?",
          type: "question",
          confirmButtonText: "Yes Proceed",
          confirmButtonColor: "#6ACF98",
          showCancelButton: true,
          cancelButtonText: "No Thanks",
          cancelButtonColor: "#EE8057"
        }).then(async (result) => {
          if (result.value) {
            this.selectedIndex = row.index;
            await db.collection('leaveRecords').doc(row.id).delete();
            swal('Success', `You have successfully deleted the leave.`, 'success');
            this.selectedIndex = -1;
          }
        })
      } catch (e) {
        swal('Error', `Something went wrong while deleting leave status.`, 'error');
      } finally {
        this.selectedIndex = -1;
      }
    },
    async withdrawLeave(row) {
      try {
        swal({
          title: "Are you sure?",
          text: "Are you sure that you want to withdraw leave?",
          type: "question",
          confirmButtonText: "Yes Proceed",
          confirmButtonColor: "#6ACF98",
          showCancelButton: true,
          cancelButtonText: "No Thanks",
          cancelButtonColor: "#EE8057"
        }).then(async (result) => {
          if (result.value) {
            this.selectedIndex = row.index;
            await db.collection('leaveRecords').doc(row.id).update({status: 'withdrawn'});
            swal('Success', `Your leave has been successfully canceled.`, 'success');
            this.selectedIndex = -1;
          }
        })
      } catch (e) {
        swal('Error', `An error occurred while canceling your leave request.`, 'error');
      } finally {
        this.selectedIndex = -1;
      }
    },
    getDuration(row) {
      let partialTime  = 0
      const fromTime = new Date(`${row.partialLeave.date}T${row.partialLeave.from}:00`);
      const toTime = new Date(`${row.partialLeave.date}T${row.partialLeave.to}:00`);
      const diffInMs = toTime - fromTime;
      const totalMinutes = Math.abs(diffInMs / (1000 * 60));
      partialTime = partialTime + totalMinutes
      return Number(partialTime/60)
    },
    parseDate(date) {
      return moment(date).format('DD MMM, YYYY')
    },
    getTitle(row, flag, index) {
      if(!flag || !row.details) {
        return true
      }
      tippy(`#${this.selectedTab}_${index}`, {
        content: row.details,
        allowHTML: true,
        theme: 'dark', // Customize the theme in your CSS if needed
        placement: 'top'
      });
    },
    emailHashGravatar(email) {
      console.log('email,', email)
      if (!email) {
        return null
      } else {
        return md5(email.toLowerCase()).toString()
      }
    },
    getStatusClass(status) {
      let statusClass = '';
      if(status === 'pending') {
        statusClass = 'badge-warning';
      } else if(status === 'approved') {
        statusClass = 'badge-success';
      } else if(status === 'rejected') {
        statusClass = 'badge-danger';
      }else if(status === 'withdrawn') {
        statusClass = 'badge-default';
      }
      return statusClass;
    },
    renderDatatable(id) {
      if($.fn.DataTable.isDataTable('#myLeavesTable')) {
        $(`#myLeavesTable`).DataTable().destroy();
      }
      setTimeout(function () {
        $(`#myLeavesTable`).dataTable({
          pagingType: "full_numbers",
          ordering: false,
          paging: true,
          destroy: true,
          retrieve: true,
          deferRender: true,
          stateSave: false,
          "bInfo" : false,
        });
      }, 0)
    },

  }
}
</script>
<style scoped>

thead{
  tr {
    th{
      text-transform: capitalize !important;
    }
  }
}
.badge-warning {
  background: #fcf3dc;
  color: #ecb62d;
}.badge-default {
  background: #f0f0f0 ;
  color: #66615b;
}.badge-success {
   background: #ebfdf3;
   color: #047a48;
 }.badge-danger {
    background: #fff0ea;
    color: #ef8156;
  }
.fa-ellipsis-v:after{
  display: none;
}
.dropdown-item.disabled, .dropdown-item:disabled{
  color: #6c757d;
}
</style>
